export default __webpack_public_path__ + "static/media/diamond.99595956.png";